import {
  GET_ROLESANDPERMISSIONS,
  GET_SUPPLIERROLE,
  FETCH_PARENT_ROLES,
  FETCH_PERMISSIONS_TREE,
  FETCH_ROLE_PERMISSIONS,
  UPDATE_ROLE_PERMISSIONS,
  FETCH_SUB_ROLES,
  FETCH_FILTERED_TREE,
  FETCH_SUB_ROLE_PERMS,
  CREATE_SUB_ROLE,
  UPDATE_SUB_ROLE,
} from 'resources/actionTypes';

function makePromiseAction(type, payload = {}) {
  let resolve;
  const promise = new Promise((res) => {
    resolve = res;
  });
  return {
    type,
    payload,
    resolve,
    then: promise.then.bind(promise),
  };
}

export function fetchRolesAndPermissions(authRole) {
  return {
    type: GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_REQUESTED,
    payload: authRole || '',
  };
}

export function fetchSupplierRole(data) {
  return {
    type: GET_SUPPLIERROLE.GET_SUPPLIERROLE_REQUESTED,
    payload: data,
  };
}

export function fetchParentRoles() {
  return makePromiseAction(FETCH_PARENT_ROLES.FETCH_PARENT_ROLES_REQUESTED);
}

export function fetchPermissionsTree() {
  return makePromiseAction(FETCH_PERMISSIONS_TREE.FETCH_PERMISSIONS_TREE_REQUESTED);
}

export function fetchRolePermissions(parentRoleId) {
  return makePromiseAction(FETCH_ROLE_PERMISSIONS.FETCH_ROLE_PERMISSIONS_REQUESTED, { parentRoleId });
}

export function updateRolePermissions(parentRoleId, permissionIds) {
  return makePromiseAction(UPDATE_ROLE_PERMISSIONS.UPDATE_ROLE_PERMISSIONS_REQUESTED, { parentRoleId, permissionIds });
}

export function fetchSubRoles(parentRoleId) {
  return makePromiseAction(FETCH_SUB_ROLES.FETCH_SUB_ROLES_REQUESTED, { parentRoleId });
}

export function fetchFilteredTree(parentRoleId) {
  return makePromiseAction(FETCH_FILTERED_TREE.FETCH_FILTERED_TREE_REQUESTED, { parentRoleId });
}

export function fetchSubRolePerms(subRoleId) {
  return makePromiseAction(FETCH_SUB_ROLE_PERMS.FETCH_SUB_ROLE_PERMS_REQUESTED, { subRoleId });
}

export function createSubRole(payload) {
  return makePromiseAction(CREATE_SUB_ROLE.CREATE_SUB_ROLE_REQUESTED, payload);
}

export function updateSubRole(subRoleId, payload) {
  return makePromiseAction(UPDATE_SUB_ROLE.UPDATE_SUB_ROLE_REQUESTED, { subRoleId, ...payload });
}
